"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiConceptEntityConceptTypeEnum;
(function (TableauNlpRefinementuiConceptEntityConceptTypeEnum) {
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["Unspecified"] = "CONCEPTTYPE_UNSPECIFIED";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["Aggregation"] = "CONCEPTTYPE_AGGREGATION";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["Boolean"] = "CONCEPTTYPE_BOOLEAN";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["Calculation"] = "CONCEPTTYPE_CALCULATION";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["Filter"] = "CONCEPTTYPE_FILTER";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["Group"] = "CONCEPTTYPE_GROUP";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["Limit"] = "CONCEPTTYPE_LIMIT";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["Sort"] = "CONCEPTTYPE_SORT";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["TableCalculation"] = "CONCEPTTYPE_TABLE_CALCULATION";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["VizType"] = "CONCEPTTYPE_VIZ_TYPE";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["AdvancedLimit"] = "CONCEPTTYPE_ADVANCED_LIMIT";
    TableauNlpRefinementuiConceptEntityConceptTypeEnum["AdvancedSort"] = "CONCEPTTYPE_ADVANCED_SORT";
})(TableauNlpRefinementuiConceptEntityConceptTypeEnum = exports.TableauNlpRefinementuiConceptEntityConceptTypeEnum || (exports.TableauNlpRefinementuiConceptEntityConceptTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiConceptEntityFilterDataTypeEnum;
(function (TableauNlpRefinementuiConceptEntityFilterDataTypeEnum) {
    TableauNlpRefinementuiConceptEntityFilterDataTypeEnum["Unspecified"] = "FILTER_DATATYPE_UNSPECIFIED";
    TableauNlpRefinementuiConceptEntityFilterDataTypeEnum["String"] = "FILTER_DATATYPE_STRING";
    TableauNlpRefinementuiConceptEntityFilterDataTypeEnum["Time"] = "FILTER_DATATYPE_TIME";
    TableauNlpRefinementuiConceptEntityFilterDataTypeEnum["Number"] = "FILTER_DATATYPE_NUMBER";
    TableauNlpRefinementuiConceptEntityFilterDataTypeEnum["Generic"] = "FILTER_DATATYPE_GENERIC";
})(TableauNlpRefinementuiConceptEntityFilterDataTypeEnum = exports.TableauNlpRefinementuiConceptEntityFilterDataTypeEnum || (exports.TableauNlpRefinementuiConceptEntityFilterDataTypeEnum = {}));
function TableauNlpRefinementuiConceptEntityFromJSON(json) {
    return TableauNlpRefinementuiConceptEntityFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiConceptEntityFromJSON = TableauNlpRefinementuiConceptEntityFromJSON;
function TableauNlpRefinementuiConceptEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : _1.TableauNlpRefinementuiEntityMetadataFromJSON(json['metadata']),
        'conceptType': !runtime_1.exists(json, 'concept_type') ? undefined : json['concept_type'],
        'filterDataType': !runtime_1.exists(json, 'filter_data_type') ? undefined : json['filter_data_type'],
    };
}
exports.TableauNlpRefinementuiConceptEntityFromJSONTyped = TableauNlpRefinementuiConceptEntityFromJSONTyped;
function TableauNlpRefinementuiConceptEntityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metadata': _1.TableauNlpRefinementuiEntityMetadataToJSON(value.metadata),
        'concept_type': value.conceptType,
        'filter_data_type': value.filterDataType,
    };
}
exports.TableauNlpRefinementuiConceptEntityToJSON = TableauNlpRefinementuiConceptEntityToJSON;
